import React, { Component } from "react";
import IAgreeTerms from "../../common/components/pageBlocks/declaration/iAgreeTerms";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import ModalPopUp from "../../common/components/pageBlocks/modalPopUp";
import commonContext, { AppContext } from "../../common/context/common";
import htmlParse from "html-react-parser";
import InputForm from "../../common/components/html/inputForm";
import OtpPopUp from "../../common/components/otpPopUp";
import IAgreeTermsInsurence from "../../common/components/pageBlocks/declaration/iAgreeTermsInsurence";
import { leadType } from "../../app";
import { Zd10SecApis } from "../apis/zd10SecApis";
import { CommonApis } from "../../common/apis/commonApis";

interface IProps {
    history: any;
}
interface IState {
    IAgreeToTermSwitch: boolean;
    IAgreeToTerm: boolean;
    IAgreeToTermInsuranceSwitch: boolean;
    IAgreeToTermInsurance: boolean;
    insuranceSwitch: boolean;
    otpPopUpSwitch: boolean;
}
export class Declaration extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Zd10SecApis;
    commonAPI: CommonApis;
    setLead: Function;
    constructor(props: IProps) {
        super(props);
        this.state = {
            IAgreeToTermSwitch: false,
            IAgreeToTerm: false,
            IAgreeToTermInsuranceSwitch: false,
            IAgreeToTermInsurance: false,
            otpPopUpSwitch: false,
            insuranceSwitch: false,
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Zd10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        this.commonAPI = (this.context as AppContext).commonAPI as CommonApis;
        const apiData = await this.commonAPI.getCaptcha(this.lead);
        this.setLead(apiData?.result);
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.commonAPI.validateCaptcha({
            ...this.lead,
            input: this.lead.captchaInput,
        });
        if (apiData.error) {
            if (apiData.error.error) {
                console.log("captcha fails");
                return;
            }
        }
        if (apiData.result.isValid) {
            if (!this.state.IAgreeToTerm) {
                console.log("IAgreeToTerm fails");
            }
            if (!this.state.IAgreeToTermInsurance) {
                if (
                    this.lead.motorInsuranceAvailed ||
                    this.lead.insuranceAvailed
                ) {
                    console.log("IAgreeToTermInsurance fails");
                }
            }
        }

        this.setLead({ termCondition: true });
        const apiDataOTP = await this.apis.acceptTermCondition({
            ...this.lead,
            termCondition: true,
        });
        console.log(apiDataOTP);
        this.setState({ otpPopUpSwitch: true });
    };
    handleOnOTPSubmit = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.finalSubmit(this.lead);
        if (apiData.result.inValidOTP) {
            console.log("otp invalid");
        } else if (apiData.result.loanAvailed) {
            this.props.history.push("confirmation");
            this.setLead({ confirmStatus: true });
        } else {
            this.props.history.push("confirmation");
            this.setLead({ confirmStatus: false });
        }
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="declaration-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <h1 className="openSans-Reg text-black my-5 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Declaration
                            </h1>
                            {/* <!-- <a href="javascript:;" className="modal-open mr-3" data-toggle="modal" data-target="termsConditionModal">sarva-suraksha-info</a> --> */}
                            <form onSubmit={(e) => this.handleOnSubmit(e)}>
                                <div className="custom-inputs tnc-general-inputs mt-4 mb-8 openSans-SemiBold text-sm md:text-lg xl:text-xl blue-link-color">
                                    <label className="inline-flex">
                                        <input
                                            type="checkbox"
                                            onChange={() =>
                                                this.setState({
                                                    IAgreeToTerm: !this.state
                                                        .IAgreeToTerm,
                                                })
                                            }
                                            checked={this.state.IAgreeToTerm}
                                        />
                                        <span></span>
                                        <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                            I agree to and accept
                                            <a
                                                href="javascript:;"
                                                className="modal-open blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                data-toggle="modal"
                                                data-target="termsConditionModal"
                                                onClick={() =>
                                                    this.setState({
                                                        IAgreeToTermSwitch: true,
                                                    })
                                                }
                                            >
                                                (i) The application filled in
                                                previous pages, (ii) Most
                                                important terms and conditions,
                                                (iii) Acceptance of fees and
                                                charges, (iv) Standing
                                                instruction for repayment of
                                                monthly instalment, (v)
                                                Relationship with directors of
                                                banks
                                            </a>
                                        </span>
                                    </label>
                                </div>
                                {this.lead.motorInsuranceAvailed ||
                                this.lead.insuranceAvailed ? (
                                    <div className="custom-inputs tnc-sarvsuraksha-inputs mt-4 mb-8 openSans-SemiBold text-sm md:text-lg xl:text-xl blue-link-color">
                                        <label className="inline-flex">
                                            <input
                                                type="checkbox"
                                                onChange={() =>
                                                    this.setState({
                                                        IAgreeToTermInsurance: !this
                                                            .state
                                                            .IAgreeToTermInsurance,
                                                    })
                                                }
                                                checked={
                                                    this.state
                                                        .IAgreeToTermInsurance
                                                }
                                            />
                                            <span></span>
                                            <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                I agree to and accept all terms
                                                & conditions for{" "}
                                                <a
                                                    href="javascript:;"
                                                    className="modal-open blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                    data-toggle="modal"
                                                    data-target="termsConditionModal"
                                                    onClick={() =>
                                                        this.setState({
                                                            insuranceSwitch: true,
                                                        })
                                                    }
                                                >
                                                    {" "}
                                                    {this.lead
                                                        .motorInsuranceAvailed &&
                                                    this.lead.insuranceAvailed
                                                        ? "(i) Sarv Suraksha Insurance,  (ii) HDFC ERGO Motor"
                                                        : this.lead
                                                              .insuranceAvailed
                                                        ? "(i) Sarv Suraksha Insurance,"
                                                        : this.lead
                                                              .insuranceAvailed
                                                        ? "(ii) HDFC ERGO Motor"
                                                        : "(i) HDFC ERGO Motor"}
                                                </a>
                                            </span>
                                        </label>
                                    </div>
                                ) : (
                                    ""
                                )}
                                <div className="flex flex-wrap">
                                    <div className="m-3 w-full md:w-3/12 inline-flex justify-center md:justify-start">
                                        {this.lead.img
                                            ? htmlParse(this.lead.img)
                                            : ""}
                                    </div>
                                    <div className="w-full md:w-3/12">
                                        <InputForm
                                            label="Enter Code"
                                            handlerOnChange={(e) =>
                                                this.setLead({
                                                    captchaInput:
                                                        e.target.value,
                                                })
                                            }
                                            errorText="Please Input Correct Captcha Code"
                                            // error={}
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex flex-wrap my-8">
                                    <button className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4">
                                        Continue
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
                {/* <!-- Terms & Conditions Popup Start --> */}
                {this.state.IAgreeToTermSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({ IAgreeToTermSwitch: false })
                        }
                    >
                        <IAgreeTerms
                            onclickhandler={() =>
                                this.setState({
                                    IAgreeToTermSwitch: false,
                                    IAgreeToTerm: true,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* <!-- Terms & Conditions Popup End -->  */}
                {/* insurence popup start */}
                {this.state.insuranceSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({ insuranceSwitch: false })
                        }
                    >
                        <IAgreeTermsInsurence
                            onclickhandler={() =>
                                this.setState({
                                    insuranceSwitch: false,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* insurence popup end */}
                {/* <!-- OTP Popup Start --> */}
                {this.state.otpPopUpSwitch ? (
                    <OtpPopUp
                        onClose={() => this.setState({ otpPopUpSwitch: false })}
                        handleOnOTPSubmit={() => this.handleOnOTPSubmit()}
                    />
                ) : (
                    ""
                )}

                {/* <!-- OTP Popup End -->  */}
            </>
        );
    }
}

export default Declaration;
